import { appSynonymGlobal } from '@/globals/appSynonym.global';
import { icons } from '@/globals/platformIcons';
import { IoIosArrowBack } from '@react-icons/all-files/io/IoIosArrowBack';
import { IoIosArrowForward } from '@react-icons/all-files/io/IoIosArrowForward';
import Image from 'next/image';
import Link from 'next/link';
import { Autoplay, Keyboard, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { PaginationOptions } from 'swiper/types';
import defaultImage from '../../../public/assets/image-placeholder.png';
import { CustomLink } from '../link/link.comp';
import { Section } from '../section/section.comp';
import { StyledDiv } from './moreApps.styles';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Hits = ({ hits }: { hits: any[] }) => {
	let pagination: PaginationOptions = {
		el: '.pagination',
		clickable: true,
		type: 'bullets',
		renderBullet: function (index: number, className: string) {
			return `<span class="${className}"></span>`;
		},
	};

	const swiperSettings = {
		navigation: {
			prevEl: '.arrow-left',
			nextEl: '.arrow-right',
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		pagination,
		autoplay: {
			delay: 2500,
			pauseOnMouseEnter: true,
			disableOnInteraction: false,
		},
		dir: 'ltr',
		slidesPerView: 1,
		spaceBetween: 20,
		breakpoints: {
			320: {
				slidesPerView: 1,
			},
			630: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			980: {
				slidesPerView: 3,
			},
			1440: {
				slidesPerView: 4,
				spaceBetween: 50,
			},
		},
	};

	return (
		<Swiper
			{...(swiperSettings || {})}
			className="swiper-container"
			modules={[Autoplay, Navigation, Pagination, Keyboard]}
			centeredSlides={false}
			speed={1000}
			loop={true}
		>
			{hits.map((hit) => (
				<SwiperSlide key={`${hit._id}-${hit.slug}`} className={`swiper`}>
					<div className="item-wrapper">
						<Image
							className="platform"
							src={(icons as any)[hit.platform] || ''}
							alt={hit.name || ''}
							width={65}
							height={65}
						/>
						<Image
							className="app"
							src={hit.icon || defaultImage}
							alt={hit.name || ''}
							width={65}
							height={65}
						/>
						<div className="content">
							<h3>
								<Link
									href={`/${hit.platform}/${
										(appSynonymGlobal as any)[hit.platform] || 'app'
									}/${hit.slug}`}
								>
									{(hit?.name || '').replace(/\&#x2011;/g, '- ') || ''}
								</Link>
							</h3>
							{hit.teaser && <p className="body-1">{hit.teaser}</p>}
						</div>
						<CustomLink
							className="btn"
							variant="secondary"
							href={`/${hit.platform}/${
								(appSynonymGlobal as any)[hit.platform] || 'app'
							}/${hit.slug}`}
						>
							Discover {(appSynonymGlobal as any)[hit.platform] || 'app'}
						</CustomLink>
					</div>
				</SwiperSlide>
			))}
		</Swiper>
	);
};

export const MoreApps = ({
	appSynonym = 'app',
	title,
	hits = [],
}: any) => {
	if (!hits?.length) {
		return null;
	}

	return (
		<Section>
			<StyledDiv>
				<p>More {appSynonym}s</p>
				<h2>{title || `${appSynonym}s You Might Like`}</h2>
				<Hits hits={hits} />
				<div className={`arrows`}>
					<div className={`arrow arrow-left`}>
						<button className={`arrow-btn`} type="button">
							<IoIosArrowBack className="icon" />
						</button>
					</div>
					<div className={`arrow arrow-right`}>
						<button className={`arrow-btn`} type="button">
							<IoIosArrowForward className="icon" />
						</button>
					</div>
				</div>
			</StyledDiv>
		</Section>
	);
};
